<div class="rel-dialog">
  <header class="rel-header">
    <h2 class="rel-header-title">Release Details</h2>
  </header>

  <form class="rel-form">
    <div mat-dialog-content class="rel-content">
      <div class="rel-meta">
        <div class="rel-meta-item">
          <span class="rel-meta-label">Source Branch</span>
          <span class="rel-meta-value">{{ data.branchName }}</span>
        </div>
        <div class="rel-meta-item">
          <span class="rel-meta-label">Team</span>
          <span class="rel-meta-value">{{ data.team || '—' }}</span>
        </div>
        <div class="rel-meta-item rel-meta-full">
          <span class="rel-meta-label">Release</span>
          <a
            class="rel-meta-value rel-meta-link"
            [href]="data.releaseLink"
            target="_blank"
            rel="noopener noreferrer"
            >{{ data.pipelineName }}<mat-icon class="rel-link-icon">open_in_new</mat-icon></a
          >
        </div>
      </div>

      <section class="rel-card">
        <div class="rel-card-title">Release Status</div>
        <mat-form-field appearance="outline" class="rel-field">
          <mat-label>Review Classification</mat-label>
          <mat-select
            [(ngModel)]="data.reviewClassification"
            (ngModelChange)="data.isTransient = isTransientClassification($event)"
            name="reviewClassification"
          >
            @for (classification of reviewClassifications; track classification) {
              <mat-option [value]="classification">
                {{ classification | reviewClassificationDisplay }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="rel-field">
          <mat-label>Change Fail</mat-label>
          <mat-select
            [(ngModel)]="data.changeFail"
            name="changeFail"
            matTooltip="Select 'Yes' if this release resulted in a production failure"
          >
            <mat-option [value]="false">Yes (Failure)</mat-option>
            <mat-option [value]="true">No (Success)</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox
          [(ngModel)]="data.isTransient"
          [disabled]="true"
          name="isTransient"
          class="rel-transient"
        >
          Transient Issue
        </mat-checkbox>
      </section>

      @if (failingEnvironments.length > 0) {
        <section class="rel-card rel-card-failure">
          <div class="rel-card-title rel-failure-title">
            <mat-icon>error_outline</mat-icon>
            Failed Stages
          </div>
          <div class="rel-env-list">
            @for (env of failingEnvironments; track env) {
              <div class="rel-env">
                <div class="rel-env-top">
                  <span class="rel-env-name">{{ env.Name }}</span>
                  <a [href]="getEnvironmentUrl(env.Name)" target="_blank" class="rel-view-failure">
                    <mat-icon>launch</mat-icon> View Failure
                  </a>
                </div>
                @if (env.RejectedDateTimeUtc) {
                  <div class="rel-env-rejected">Rejected {{ formatTime(env.RejectedDateTimeUtc) }}</div>
                }
              </div>
            }
          </div>
        </section>
      }

      @if (descriptions.length > 0) {
        <section class="rel-card">
          <div class="rel-card-title">
            Description
            <span class="rel-desc-counter">{{ currentIndex + 1 }} / {{ descriptions.length }}</span>
          </div>
          <mat-form-field class="rel-field" appearance="outline">
            <textarea
              matInput
              [placeholder]="currentDescription.Description"
              title="currentDescription.Description"
              [(ngModel)]="currentDescription.Description"
              (ngModelChange)="addDescription($event)"
              name="description"
              rows="8"
              style="resize: vertical;"
              [readonly]="true"
              [disabled]="true"
            ></textarea>
          </mat-form-field>
          <div class="rel-nav">
            <button
              type="button"
              class="rel-chevron"
              (keydown.enter)="previousDescription()"
              (click)="previousDescription()"
              [disabled]="currentIndex === 0"
              aria-label="Previous description"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <div class="rel-dots">
              @for (description of descriptions; track description; let i = $index) {
                <span class="rel-dot" [ngClass]="{ active: i === currentIndex }"></span>
              }
            </div>
            <button
              type="button"
              class="rel-chevron"
              (keydown.enter)="nextDescription()"
              (click)="nextDescription()"
              [disabled]="currentIndex === descriptions.length - 1"
              aria-label="Next description"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </section>
      }
    </div>

    <div class="rel-footer">
      <button mat-button type="button" class="rel-btn-cancel" (click)="onClose()">Cancel</button>
      <span class="rel-footer-spacer"></span>
      @if (descriptions.length > 0) {
        <button
          mat-stroked-button
          type="button"
          class="rel-btn-secondary"
          (click)="openAddDescriptionModal(data, currentDescription)"
        >
          Update Current
        </button>
      }
      <button
        mat-stroked-button
        type="button"
        class="rel-btn-secondary"
        (click)="openAddDescriptionModal(data)"
      >
        <mat-icon>add</mat-icon> Description
      </button>
      <button mat-flat-button type="button" class="rel-btn-primary" (click)="updateRelease()">
        <mat-icon>save</mat-icon> Save
      </button>
    </div>
  </form>
</div>
